var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarningsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 103.75H30C22.415 103.75 16.25 97.585 16.25 90V30C16.25 22.415 22.415 16.25 30 16.25H90C97.585 16.25 103.75 22.415 103.75 30V90C103.75 97.585 97.585 103.75 90 103.75ZM30 23.75C26.555 23.75 23.75 26.555 23.75 30V90C23.75 93.445 26.555 96.25 30 96.25H90C93.445 96.25 96.25 93.445 96.25 90V30C96.25 26.555 93.445 23.75 90 23.75H30Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 60V80C43.75 82.07 42.07 83.75 40 83.75C37.93 83.75 36.25 82.07 36.25 80V60C36.25 57.93 37.93 56.25 40 56.25C42.07 56.25 43.75 57.93 43.75 60ZM60 36.25C57.93 36.25 56.25 37.93 56.25 40V80C56.25 82.07 57.93 83.75 60 83.75C62.07 83.75 63.75 82.07 63.75 80V40C63.75 37.93 62.07 36.25 60 36.25ZM80 46.25C77.93 46.25 76.25 47.93 76.25 50V80C76.25 82.07 77.93 83.75 80 83.75C82.07 83.75 83.75 82.07 83.75 80V50C83.75 47.93 82.07 46.25 80 46.25Z",
    fill: "#5B55FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningsEmpty);
export default __webpack_public_path__ + "static/media/Earnings-empty.82ea96aec09ba81b12d4066a8bbb6917.svg";
export { ForwardRef as ReactComponent };